<template>
  <div>
    <md-dialog-confirm
      :md-active.sync="confirmDeleteUserDialog.active"
      :md-title="$t('dialog.confirm-delete.title')"
      :md-confirm-text="$t('dialog.confirm-delete.yes')"
      :md-cancel-text="$t('dialog.confirm-delete.no')"
      @md-confirm="confirmDeleteUserDialog.deleteAction(confirmDeleteUserDialog.userId)" />
    <md-dialog-confirm
      :md-active.sync="confirmRestoreUserDialog.active"
      :md-title="$t('dialog.confirm-restore.title')"
      :md-confirm-text="$t('dialog.confirm-restore.yes')"
      :md-cancel-text="$t('dialog.confirm-restore.no')"
      @md-confirm="confirmRestoreUserDialog.action(confirmRestoreUserDialog.userId)" />
      <md-table
        v-model="users.content"
        :md-sort.sync="currentSort"
        :md-sort-order.sync="currentSortOrder"
        :md-sort-fn="customSort">
        <md-table-row slot="md-table-row" slot-scope="{ item, index }" @mouseover="currentHoverIndex = index"
          @mouseleave="currentHoverIndex = null" class="md-accent">
          <md-table-cell
            :md-label="$t(`views.admin.dashboard.${whatUserList}.table.label.first-name`)"
            md-sort-by="firstName">
            {{ item.firstName }}
          </md-table-cell>
          <md-table-cell
            :md-label="$t(`views.admin.dashboard.${whatUserList}.table.label.last-name`)"
            md-sort-by="lastName">
            {{ item.lastName }}
          </md-table-cell>
          <md-table-cell
            :md-label="$t(`views.admin.dashboard.${whatUserList}.table.label.email`)"
            md-sort-by="email">
            {{ item.email }}
          </md-table-cell>
          <md-table-cell
            :md-label="$t(`views.admin.dashboard.${whatUserList}.table.label.valid-from`)"
            md-sort-by="validFrom">
            {{ item.validFrom | moment('L') }}
          </md-table-cell>
          <md-table-cell
            :md-label="$t(`views.admin.dashboard.${whatUserList}.table.label.valid-until`)"
            md-sort-by="validTo">
              {{ item.validTo | moment('L') }}
          </md-table-cell>
          <div class="actions-users" v-if="currentHoverIndex == index"
               :style="setUserActions">
            <md-button
                v-if="hasAccess(getUserEditPrivilege())"
                @click="editUser(item.id)"
                class="md-icon-button">
              <md-icon>edit</md-icon>
              <md-tooltip md-direction="top">{{ $t('edit') }}</md-tooltip>
            </md-button>
            <md-button
                v-if="hasAccess(getUserDeletePrivilege()) && userId !== item.keycloak_id && item.state == userStatus.Active"
                class="md-icon-button"
                @click="showConfirmDeleteUser(item.id, deleteUser)">
              <md-icon>delete</md-icon>
              <md-tooltip md-direction="top">{{ $t('delete') }}</md-tooltip>
            </md-button>
            <md-button
                v-else-if="hasAccess(getUserDeletePrivilege()) && userId !== item.keycloak_id && item.state == userStatus.Inactive"
                class="md-icon-button"
                @click="showConfirmRestoreUser(item.id, restoreUser)">
              <md-icon>restore_from_trash</md-icon>
              <md-tooltip md-direction="top">{{ $t('restore') }}</md-tooltip>
            </md-button>
          </div>
        </md-table-row>
        <md-table-empty-state
            v-if="!loading"
            class="md-layout-item md-size-100"
            :md-label="$t('dialog.noData')" />
        <Spiner :loading="loading" />
      </md-table>
      <paginator
        :page.sync="currentPage"
        :length="users.totalElements || 0"
        :page-size.sync="pageSize"
        @pageChange="loadUsers(currentPage, pageSize, sort, searchVal)" />
    </div>
</template>
<script>
import Paginator from "@/components/Paginator";
import { adminsEndpoint, usersEndpoint } from "@/services/adsign-backend/endpoints";
import { mapGetters, mapActions } from "vuex";
import sortSupport from "@/mixins/sortSupport";
import Spiner from '@/components/Spiner'
import store from '@/store'

export default {
  name: "UserList",
  mixins: [sortSupport],
  components: { Paginator, Spiner },
  computed: {
    ...mapGetters("auth", ["hasAccess", "userName", "userId", "userType"]),
    ...mapGetters("misc", ["currentSortList"]),

    setUserActions(){
      if(this.whatUserList == "users") return "margin-right: 0%";
      else if(this.whatUserList == "polsat") return "margin-right: -100%"
      else return "margin-right: -200%";
    }
  },
  created(){
    this.currentSort = this.currentSortList.sortBy
    this.currentSortOrder = this.currentSortList.sortOrder
    this.pageSize = this.currentSortList.pageSize
  },
  props: {
    whatUserList: {
      type: String,
      required: true
    },
    showInactiveUsers: {
      type: Boolean,
      required: true
    },
    filterValue: {
      type: String,
      default: ''
    }
  },
  watch: {
    showInactiveUsers: function() {
      this.customSort(this.value);
    }
  },
  data: () => ({
    userStatus: {
      Active: 'ACTIVE',
      Inactive: 'INACTIVE',
    },
    searchVal: '',
    currentSort: "lastName",
    currentSortOrder: "asc",
    confirmDeleteUserDialog: {
      active: false,
      userId: undefined,
      userName: undefined,
      deleteAction: undefined
    },
    confirmRestoreUserDialog: {
      active: false,
      userId: undefined,
      userName: undefined,
      action: undefined
    },
    users: {
      content: [],
      pageable: {
        pageNumber: 0,
        pageSize: 0,
        filter: null,
      },
      totalElements: null
    },
    createRoute: {
      users: '/client-user',
      polsat: '/polsat-user',
      admins: '/admin-user'
    },
    currentHoverIndex: null,
    loading: false,
  }),
  methods: {
    getListLabel() {
      return `views.admin.dashboard.${this.whatUserList}.label`;
    },
    loadUsers(page, pageSize, sort, filter) {
      this.loading = true
      this.chooseLoadEndpoint(page, pageSize, sort, filter, this.showInactiveUsers)
        .then(response => {
          this.users = response.data;
          this.updateCurrentArray(response.data.content);
        })
        .catch(this.handleServerValidationError)
        .finally(() => this.loading = false, store.commit('misc/SORT_LIST', {sortBy: this.currentSort, sortOrder: this.currentSortOrder, pageSize: this.pageSize}))
    },
    chooseLoadEndpoint(page, pageSize, sort, filter, showInactiveUsers) {
      switch (this.whatUserList) {
        case "users":
          return usersEndpoint.getClientUsers(page - 1, pageSize, sort, filter, showInactiveUsers);
          break;

        case "polsat":
          return usersEndpoint.getPolsatMediaUsers(page - 1, pageSize, sort, filter, showInactiveUsers);
          break;

        case "admins":
          return adminsEndpoint.getAdminUsers(page - 1, pageSize, sort, filter, showInactiveUsers);
          break;
      };
    },
    customSort(value) {
      this.loadUsers(this.currentPage, this.pageSize, this.sort, this.searchVal);
      return value;
    },
    editUser(id) {
      this.$router.push(this.chooseEditRoute(id));
    },
    chooseEditRoute(id) {
      switch (this.whatUserList) {
        case "users":
          return `/client-user/${id}`;
          break;

        case "polsat":
          return `/polsat-user/${id}`;
          break;

        case "admins":
          return `/admin-user/${id}`;
          break;
      };
    },
    getCreateRoute() {
      return this.createRoute[this.whatUserList];
    },
    showConfirmDeleteUser(userId, action) {
      this.confirmDeleteUserDialog.active = true;
      this.confirmDeleteUserDialog.userId = userId;
      this.confirmDeleteUserDialog.deleteAction = action;
    },
    showConfirmRestoreUser(userId, action) {
      this.confirmRestoreUserDialog.active = true;
      this.confirmRestoreUserDialog.userId = userId;
      this.confirmRestoreUserDialog.action = action;
    },
    deleteUser(userId) {
      this.chooseDeleteEndpoint(userId).then(() => {
        this.loadUsers(this.currentPage, this.pageSize, this.sort, this.searchVal);
      });
    },
    restoreUser(userId) {
      this.chooseRestoreEndpoint(userId).then(() => {
        this.loadUsers(this.currentPage, this.pageSize, this.sort, this.searchVal);
      });
    },
    chooseDeleteEndpoint(userId) {
      switch (this.whatUserList) {
        case "users":
        case "polsat":
          return usersEndpoint.deleteUser(userId);
          break;

        case "admins":
          return adminsEndpoint.deleteAdminUser(userId);
          break;
      };
    },

    chooseRestoreEndpoint(userId) {
      switch (this.whatUserList) {
        case "users":
        case "polsat":
          return usersEndpoint.restoreUser(userId);
          break;

        case "admins":
          return adminsEndpoint.restoreAdminUser(userId);
          break;
      };
    },
    getUserCreatePrivilege() {
      switch (this.whatUserList) {
        case "users":
          return "PRIVILEGE_USER_CREATE";
          break;

        case "polsat":
          return "PRIVILEGE_USER_CREATE";
          break;

        case "admins":
          return "PRIVILEGE_ADMIN_CREATE";
          break;
      };
    },
    getUserEditPrivilegeByUserTypeAndUserId(item){
        if(this.userId !== item.keycloak_id) return true;
        else return false;
    },
    getUserEditPrivilege() {
      switch (this.whatUserList) {
        case "users":
          return "PRIVILEGE_USER_UPDATE";
          break;

        case "polsat":
          return "PRIVILEGE_USER_UPDATE";
          break;

        case "admins":
          return "PRIVILEGE_ADMIN_UPDATE";
          break;
      };
    },
    getUserDeletePrivilege() {
      switch (this.whatUserList) {
        case "users":
          return "PRIVILEGE_USER_DELETE";
          break;

        case "polsat":
          return "PRIVILEGE_USER_DELETE";
          break;

        case "admins":
          return "PRIVILEGE_ADMIN_DELETE";
          break;
      };
    },
    ...mapActions('misc', ['setTabsNavObj']),
    ...mapActions('details-panel', ['showPanel', 'detailsPanelComponentName', 'updateCurrentArray', 'currentlyDisplayedItemIndex']),
    manageHovering(itemIndex, action) {
      if (!!this.users && this.users.content && this.users.content.length > 0) {
        if (action === 'over') {
          this.currentlyHoveredIndex = itemIndex;
        } else if (action === 'leave') {
          this.currentlyHoveredIndex = null;
        }
      }
    },
    showUserDetails(index) {
      this.detailsPanelComponentName("UserDetails");
      this.currentlyDisplayedItemIndex(index);
      this.showPanel(true);
    },
  },
  mounted() {
    this.setTabsNavObj({
      routeForButton: this.getCreateRoute(),
      translationParameter: this.whatUserList,
      alternateTranslationPath: '',
      alternateCallback: () => {}
    });
    this.$watch(() => this.filterValue, (result) => {
      this.searchVal = result
      this.loadUsers(this.currentPage, this.pageSize, this.sort, result);
    })
  },
  destroyed() {
    this.showPanel(false);
    this.updateCurrentArray(null);
  }
};
</script>
<style lang="scss" scoped>
.fixed-item-width {
  width: 120px;
}

.fixed-table-row {
  height: 56px;
}

</style>
